import { render, staticRenderFns } from "./enterinput.vue?vue&type=template&id=67861b1a&scoped=true"
import script from "./enterinput.vue?vue&type=script&lang=js"
export * from "./enterinput.vue?vue&type=script&lang=js"
import style0 from "./enterinput.vue?vue&type=style&index=0&id=67861b1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67861b1a",
  null
  
)

export default component.exports